export default __webpack_public_path__ + "static/media/fordata-white.d3ac20fb.png";